
const digest = '2a54509db7d1a7bbb49e9e4e098608ca11b573b9a8463613962c699c131c8bd4';
const classes = {"background":"_background_j0rmj_1","grid":"_grid_j0rmj_6"};
const css = `._background_j0rmj_1 {
  background: #fbfbfd;
  padding-top: 12px;
}

._grid_j0rmj_6 {
  margin: 0 auto;
  display: grid;
  gap: 24px;
  background: #fbfbfd;
  padding: 12px 12px 24px;
}

@media (min-width: 600px) {
  ._grid_j0rmj_6 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 900px) {
  ._grid_j0rmj_6 {
    grid-template-columns: repeat(6, 1fr);
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  